import { AxiosResponse } from "axios";
import { ENDPOINTS } from "../../../../processes/api/endpoints";
import { Base3DApi } from "../Base3DApi";
import { ICompositorImageData } from "./type";

export class CompositorImageApi extends Base3DApi {
  public async getCompositorImage(
    data: ICompositorImageData
  ): Promise<AxiosResponse<Blob>> {
    return await this.axiosInstance.get(ENDPOINTS.COMPOSITOR.IMAGE, {
      responseType: "blob",
      params: { ...data, config: JSON.stringify(data.config) },

      baseURL: Base3DApi.getBaseURL(),
    });
  }
}
